import React from 'react';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import AppRadio from './AppRadio';

const useStyles = makeStyles((theme) => ({
  card: {
    border: '0.5px solid rgba(122,122,122,0.6)',
    borderRadius: 10,
  },
  actions: {
    borderTop: '0.5px solid rgba(122,122,122,0.6)',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  button: {
    fontWeight: 400,
  },
  content: {
    cursor: 'pointer',
  },
  info: {
    fontWeight: 400,
    fontSize: '.8rem',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: 'capitalize',
  },
  radio: {
    height: 'min-content',
  },
}));

const AddressCard = ({ item, deleteAddress, handleChangeMain, editAddress }) => {
  const classes = useStyles();

  // console.log(item.city.name)

  // const {
  //   name,
  //   address,
  //   city: { name: city },
  //   state: { name: state },
  //   main,
  // } = item;

  return (
    <Box display="flex" flexDirection="column" className={classes.card}>
      <Box display="flex" className={classes.content} onClick={handleChangeMain}>
        <AppRadio
          checked={item?.main === 'true'}
          className={classes.radio}
          value="e"
          name="radio-button-demo"
          color="default"
          inputProps={{ 'aria-label': 'E' }}
          size="small"
        />
        <Box display="flex" flexDirection="column" className={classes.info}>
          <Typography variant="inherit">{item?.name}</Typography>
          <Typography variant="inherit">{item?.address}</Typography>
          <Typography variant="inherit">
            {item?.city?.name}, {item?.state?.name}
          </Typography>
          <Typography variant="inherit">080012</Typography>
        </Box>
      </Box>
      <Box display="flex" className={classes.actions}>
        <Button size="small" className={classes.button} onClick={editAddress} startIcon={<EditOutlinedIcon />}>
          Modificar
        </Button>
        <Box clone ml={3}>
          <Button
            size="small"
            className={classes.button}
            onClick={deleteAddress}
            startIcon={<DeleteOutlineOutlinedIcon />}
          >
            Eliminar
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddressCard;
